export const headers = [
  { name: 'Nº NF', field: 'nNF', sortable: true },
  { name: 'Emitente', field: 'xNome', sortable: true },
  { name: 'CNPJ', field: 'CNPJ', sortable: true },
  { name: 'Emissão', field: 'dhEmi', sortable: true },
  { name: 'Recebimento', field: 'dhRecbto', sortable: true },
  { name: 'Valor', field: 'vNF', sortable: false },
  { name: 'Situação', field: 'cSitNFe', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
